import {Component, OnInit} from '@angular/core';
import {Router,ActivatedRoute} from '@angular/router';
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {UserService} from "../services/user.service";
import {TransactionService} from "../services/transaction.service";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  registerForm: any;
  errorMsg: any;
  submitted = false;
  inpReadonly = false;
  clicked = false;
  deposit_whatsapp:string = '';

  constructor(private router: Router,private route: ActivatedRoute, private fb: FormBuilder, private userService: UserService,private transactionService:TransactionService) {
  }

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      role: ['5',],
      name: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      contact: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      // email:['',[Validators.required,Validators.email]],
      referer_name: [null,]
    });
    // Accessing query parameters
    this.route.queryParams.subscribe(params => {
      const parameterValue = params['username'];
      if(parameterValue){
        this.registerForm.get('referer_name').setValue(parameterValue);
        this.inpReadonly = true;
      }
    });
    this.getPopupDataRequests();
  }

  get registerFormControl() {
    return this.registerForm.controls;
  }

  depositSupport(){
    location.href = "https://wa.me/91"+this.deposit_whatsapp;
  }

  getPopupDataRequests() {
    this.transactionService.getPopupDataRequests().subscribe((res: any) => {
      this.deposit_whatsapp = res[0].deposit_whatsapp;
    });
  }

  register() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    } else {
      this.clicked = true;
      this.userService.createUser(this.registerForm.value).subscribe((res: any) => {
        this.clicked = false;
        if (res.errors) {
          this.errorMsg = res.errors;
        } else {
          this.router.navigateByUrl('login?message=RegistrationSuccessful');
        }
      },
      (error) => {
        this.clicked = false;
        this.clicked=false;
          if (error.status === 422) {
            this.errorMsg = error.error.errors.map((errorObj: any) => errorObj.username).join(' ');
            setTimeout(() => {
              this.errorMsg="";
            },5000);
          }
      });
    }

  }

}
